import { Article, ArticleListType } from "../../Model/Article"
import {
  collection,
  doc,
  getDoc,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  where,
} from "firebase/firestore"
import firebaseApp from "../../Config/firebase"

const db = getFirestore(firebaseApp)

/**
 * get Article from aid - article id
 * @param urlTitle
 */

const getArticle = (
  urlTitle: string
): Promise<
  | {
      success: true
      data: Article
    }
  | {
      success: false
    }
> => {
  return new Promise(async (resolve) => {
    let Article: Article | null = null
    let dbRef: any = collection(db, "Article")

    dbRef = query(dbRef, where("isPublish", "==", true))
    dbRef = query(dbRef, where("urlTitle", "==", urlTitle))

    const querySnapshot = await getDocs(dbRef)
    querySnapshot.forEach((doc) => {
      if (doc.exists()) {
        Article = doc.data() as Article
      }
    })
    if (Article !== null) {
      return resolve({
        success: true,
        data: Article,
      })
    }
    return resolve({
      success: false,
    })
  })
}

/**
 * get published Articles from db
 */

const listPublishedArticle = (
  lang: string,
  excludeArticle?: string,
  limitArticle?: number
): Promise<
  | {
      success: true
      data: Article[]
    }
  | {
      success: false
    }
> => {
  return new Promise(async (resolve) => {
    let dbRef: any = collection(db, "Article")
    if (lang === "EN") {
      dbRef = query(dbRef, where("language", "==", "EN"))
    } else if (lang === "CHI") {
      dbRef = query(dbRef, where("language", "==", "CHI"))
    }

    dbRef = query(dbRef, where("isPublish", "==", true))
    dbRef = query(dbRef, orderBy("createDate", "desc"))
    if (limitArticle) {
      dbRef = query(dbRef, limit(limitArticle))
    }

    await getDocs(dbRef)
      .then((docs) => {
        if (!docs.empty) {
          let articles: Article[] = []
          docs.forEach((doc) => {
            const a: Article = doc.data() as Article
            if ((a.urlTitle as string) !== excludeArticle) {
              articles.push({
                id: doc.id,
                ...(doc.data() as object),
              } as Article)
            }
          })
          return resolve({
            success: true,
            data: articles,
          })
        }
        return resolve({
          success: false,
        })
      })
      .catch((err) => console.log(err))
  })
}

const getArticleList = (
  listType: ArticleListType
): Promise<{ success: true; articles: Article[] } | { success: false }> => {
  return new Promise(async (resolve) => {
    let docRef: any = doc(db, "Utils", "Homepage")

    await getDoc(docRef)
      .then((doc: any) => {
        let blogs: Article[] = []
        let allPromise: Promise<any>[] = []

        if (doc.exists()) {
          let blogList: string[] = []
          if (listType === ArticleListType.HOMEPAGE) {
            blogList = doc.data().homepageBlogList
          } else if (listType === ArticleListType.KOL) {
            blogList = doc.data().kolBlogList
          } else if (listType === ArticleListType.CUSTOMER) {
            blogList = doc.data().customerBlogList
          }

          if (blogList && Array.isArray(blogList)) {
            blogList.map((blogID: string) => {
              allPromise.push(
                new Promise(async (resolve1) => {
                  await getArticle(blogID)
                    .then((result) => {
                      if (result.success) {
                        blogs.push(result.data)
                        return resolve1(null)
                      }
                      return resolve1(null)
                    })
                    .catch((err) => console.log(err))
                })
              )
            })

            Promise.all(allPromise).then((result) => {
              return resolve({
                success: true,
                articles: blogs,
              })
            })
          } else {
            return resolve({
              success: false,
            })
          }
        }
      })
      .catch((err) => console.log(err))
  })
}

export { getArticle, listPublishedArticle, getArticleList }
